import { getPage } from "./getPage";


const getLikes = () => JSON.parse(localStorage.getItem('likes') || '{}');
const setLikes = (likes) => localStorage.setItem('likes', JSON.stringify(likes));

const updateLikeState = (likeElement, sku) => {
  const likes = getLikes();
  if (likes[sku]) {
    likeElement.classList.add('active');
  } else {
    likeElement.classList.remove('active');
  }
};

const handleLikeClick = (likeElement, sku) => {
  const likes = getLikes();
  if (likes[sku]) {
    delete likes[sku];
  } else {
    likes[sku] = true;
  }
  setLikes(likes);
  document.querySelectorAll('.like').forEach(like => {
    const currentSku = like.dataset.sku;
    updateLikeState(like, currentSku);
  });
};

export const getProduct = (products, containerType) => {
  const getRandomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

  let productHTML = '';
  let numProducts;

  if (containerType === 'ha-product__content') {
    numProducts = 5;
    const randomProducts = [];
    while (randomProducts.length < numProducts) {
      const randomIndex = getRandomInt(0, products.length - 1);
      const randomProduct = products[randomIndex];
      if (!randomProducts.some(product => product.sku === randomProduct.sku)) {
        randomProducts.push(randomProduct);
      }
    }
    productHTML = randomProducts.map(product => `
      <div class="ha-product__box">
        <div class="data-order-type get_product" data-order-type="${product.sku}"></div>
        <div class="ha-product__info">
          <div class="ha-product__price">${window.options?.currency ? window.options.currency : '$'}${product.price.toFixed(2)}</div>
          <div class="like" data-sku="${product.sku}"></div>
        </div>
        <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
        <span class="ha-product__name">${product.templates.title}</span>
        <div class="ha-product__btn">view product</div>
      </div>
    `).join('');
  } else if (containerType === 'home-product__content') {
    const contentContainer = $(`.${containerType}`);
    const tabList = $('.tab-list');
    const tabItems = $('.tab-item');

    function renderProducts(productsToRender) {
      productHTML = productsToRender
        .map(product => `
          <div class="home-product__box">
            <div class="data-order-type get_product" data-order-type="${product.sku}"></div>
            <div class="home-product__info">
              <div class="home-product__price">
                ${window.options?.currency ? window.options.currency : '$'}${product.price.toFixed(2)}
              </div>
              <div class="like" data-sku="${product.sku}"></div>
            </div>
            <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
            <span>${product.templates.title}</span>
            <div class="home-product-btn">VIEW PRODUCT</div>
          </div>
        `).join('');

      contentContainer.html(productHTML);

      $('.get_product').off('click').on('click', function (e) {
        const $target = $(e.currentTarget);
        const sku = $target.data('order-type');
        localStorage.setItem('product', sku);

        window.location.href = `${getPage('product')}&id=${sku}`;
      });

      document.querySelectorAll('.like').forEach(like => {
        const sku = like.dataset.sku;
        updateLikeState(like, sku);
        like.onclick = () => handleLikeClick(like, sku);
      });
    }

    function handleTabClick(event) {
      const tab = $(event.target).data('tab');

      tabItems.removeClass('active');
      $(event.target).addClass('active');

      if (tab === 'all') {
        renderProducts(products);
      } else if (tab === 'most-viewed') {
        renderProducts(products.slice(0, 4));
      } else if (tab === 'trend-now') {
        renderProducts(products.slice(4, 10));
      }
    }

    tabList.on('click', '.tab-item', handleTabClick);

    renderProducts(products);
  } else if (containerType === 'product-list') {
    numProducts = products.length;
    productHTML = products.map(product => `
       ${product.templates.title} <br>
       ${product.templates.title.toUpperCase()} BOTTLE - ${window.options?.currency ? window.options.currency : '$'}${product.price.toFixed(2)}<br> <br>
    `).join('');
  } else if (containerType === 'ap-content') {
    numProducts = products.length;
    productHTML = products.map(product => `
      <div class="ap-item">
        <div class="data-order-type get_product" data-order-type="${product.sku}"> </div>
        <div class="ap-item__info">
          <div class="ap-item__price">
            ${window.options?.currency ? window.options.currency : '$'}${product.price.toFixed(2)}
          </div>
          <div class="like" data-sku="${product.sku}"></div>
        </div>
        <div  class="ap-item__img">
          <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
        </div>
        <div class="ap-item__name">${product.templates.title}</div>
        <div class="ap-item__btn">VIEW PRODUCT</div>
      </div>
    `).join('');
  } else if (containerType === 'banner-flex') {
    numProducts = 4;
    const randomProducts = [];
    while (randomProducts.length < numProducts) {
      const randomIndex = getRandomInt(0, products.length - 1);
      const randomProduct = products[randomIndex];
      if (!randomProducts.some(product => product.sku === randomProduct.sku)) {
        randomProducts.push(randomProduct);
      }
    }
    productHTML = randomProducts.map(product => `
      <div class="banner-box">
        <div class="banner-box__img">
          <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
        </div>
        <div class="banner-box__body">
          <div class="banner-box__name">${product.templates.title}</div>
          <div class="banner-box__desc">${product.description}</div>
          <div class="banner-box__button get_product" data-order-type="${product.sku}">GO TO SHOP</div>
        </div>
      </div>
    `).join('');
  } else if (containerType === 's-1-product') {
    numProducts = products.length;
    productHTML = products.map(product => `
      <div class="prd-item">
        <div class="data-order-type get_product" data-order-type="${product.sku}"> </div>
        <div class="top-side">
          <div class="left-side">
            <img src="/static/common/shared/products/${product.templates.imageLink}" alt="${product.templates.title}">
          </div>
          <div class="right-side">
            <div class="prd-name">${product.templates.title}</div>
            <div class="prd-exp">${product.description}</div>
            <div class="prd-price">${window.options?.currency ? window.options.currency : '$'}${product.price.toFixed(2)}</div>
          </div>
        </div>
        <div class="bottom-side">
           <div class="prd-btn">VIEW PRODUCT</div>
        </div>
      </div>
    `).join('');
  }

  $(`.${containerType}`).html(productHTML);

  $('.get_product').click(function (e) {
    const $target = $(e.currentTarget);
    const sku = $target.data('order-type');
    localStorage.setItem('product', sku);

    window.location.href = `${getPage('product')}&id=${sku}`;
  });

  if (containerType !== 'product-list') {
    document.querySelectorAll('.like').forEach(like => {
      const sku = like.dataset.sku;
      updateLikeState(like, sku);
      like.onclick = () => handleLikeClick(like, sku);
    });
  }
};